import { ProfileType } from 'helpers/types';
import { createAction } from 'redux-act';

export const auth: any = createAction('auth', (payload:any) => (payload));
export const authSignup: any = createAction('authSignup', (payload:any) => (payload));
export const setProfile: any = createAction('setProfile', (profile:ProfileType) => ({ profile }));
export const setMessage: any = createAction('setMessage', (message:String) => ({ message }));
export const getProfile: any = createAction('getProfile', (user_id:string) => ({ user_id }));
